import type { LocaleMessageSchema } from '../types';

export default {
  Common: {
    loading: 'Caricamento...',
  },
  errors: {
    session_create_error:
      'Impossibile creare la sessione.\nPer favore riprova.',
    session_continue_error:
      "Non siamo riusciti a caricare la tua sessione. Per favore riprova. Se il problema persiste, contatta il supporto a service{'@'}theartisan.ai.",
    kiosk_not_found: 'Impossibile caricare il chiosco.\nPer favore riprova.',

    art_style_missing:
      'Nessuno stile artistico è stato\naggiunto a questo chiosco',
    art_style_fetch_error: 'Impossibile caricare lo stile artistico',
    art_style_preload_error:
      "Impossibile caricare l'anteprima dello stile artistico",

    face_detection_server_error:
      'Impossibile elaborare la foto. Si prega di riprovare.',
    face_detection_preload_error:
      'Errore durante il precaricamento dei volti rilevati',
    face_detection_no_faces:
      "Nessun volto rilevato. Per favore prova a scattare un'altra foto.",

    photo_webcam_not_allowed: 'Permesso per la webcam negato',
    photo_webcam_not_found:
      'Webcam non trovata. Controlla se è collegata al chiosco.',
    photo_webcam_hardware_error:
      'La webcam è occupata o non funziona.\nRiprova o chiedi assistenza.',
    photo_webcam_photo_failed: 'Impossibile scattare una foto\ncon la webcam',

    photo_phone_missing_session_id:
      'Non abbiamo trovato la tua sessione.\nPer favore scansiona di nuovo il codice QR.',
    photo_phone_missing_kiosk_slug:
      "Chiosco non trovato nella tua sessione. Se il problema persiste, contatta il supporto a service{'@'}theartisan.ai.",
    photo_phone_limit_exceeded: 'Troppe foto selezionate',
    photo_phone_qr_error:
      'Impossibile generare il codice QR\nper il caricamento delle foto',

    photo_file_unsupported_type: 'Tipo di file non supportato',
    photo_file_cannot_process:
      "Impossibile elaborare questa foto.\nPer favore prova con un'altra.",
    photo_file_cannot_process_heic:
      "Impossibile elaborare foto in formato HEIC.\nPer favore prova con un'altra.",

    portrait_generation_error:
      'Si è verificato un errore durante la generazione del ritratto. Per favore riprova.',
    portrait_generation_faces_not_selected:
      'Nessun volto selezionato per\nla generazione del ritratto',
    portrait_generation_style_not_selected:
      'Nessuno stile artistico selezionato per\nla generazione del ritratto',
    portrait_generation_over_limit: 'Troppi tentativi di generazione',

    portraits_download_session_error:
      "Non abbiamo trovato la tua sessione. Controlla il codice inserito. Se il problema persiste, contatta il supporto a service{'@'}theartisan.ai.",
    portraits_download_kiosk_error:
      "Chiosco non trovato nella tua sessione. Se il problema persiste, contatta il supporto a service{'@'}theartisan.ai.",
    portraits_download_portraits_error:
      "Nessun ritratto trovato nella tua sessione. Se il problema persiste, contatta il supporto a service{'@'}theartisan.ai.",

    payment_partner_mode_missing_stripe_account:
      "La modalità di pagamento partner richiede un account Stripe Connect. Configura l'account Stripe del partner o passa alla modalità di pagamento piattaforma.",

    api_error_missing_session_id: 'Sessione non trovata',
    api_error_email_code_validation:
      'Impossibile validare il codice di pagamento. Per favore riprova.',
  },

  /**
   * Global components
   */

  OverlayError: {
    buttons: {
      close: 'Chiudi',
      restart: 'Ricomincia',
      retry: 'Riprova',
    },
  },
  Logo: {
    startOver: 'Ricomincia',
  },
  Copyright: {
    copyright: 'powered by TheArtisan.ai',
    distribution: 'distribuito da',
    terms:
      'Scattando una foto su questo dispositivo, accetti le nostre politiche e i termini. Per consultarli, per favore',
    termsLink: 'clicca qui',
  },
  IdlePopup: {
    title: 'Sei ancora qui?',
    caption: 'La tua sessione terminerà se sei inattivo.',
    buttonContinue: 'Sì, sono ancora qui',
    buttonRestart: 'No, ricomincia',
  },
  GDPRConsent: {
    title: 'Consenso richiesto',
    consentText:
      'Abbiamo bisogno del tuo consenso per elaborare le tue caratteristiche facciali (dati biometrici) per creare trasformazioni artistiche. Puoi procedere solo se hai 16 anni o più (o hai il consenso dei genitori).',
    buttonConsent: 'Accetto',
    buttonDecline: 'Non accetto',
    privacyPolicyLink: 'Visualizza informativa sulla privacy',
    declineMessage: 'Non puoi procedere senza consenso',
  },
  StepProgressIndicator: {
    photoShort: 'Foto',
    photoLong: 'Scatta Foto',
    facesShort: 'Volti',
    facesLong: 'Scegli Volti',
    groupPortraitsShort: 'Gruppo',
    groupPortraitsLong: 'Ritratti di gruppo',
    portraitsShort: 'Ritratti',
    portraitsLong: 'Scegli Ritratti',
    printShort: 'Stampa',
    printLong: 'Paga e Stampa',
    sendToPickupShort: 'Ritiro',
    sendToPickupLong: 'Invia al ritiro',
  },
  UploadedPhotosSidebar: {
    title: 'Le tue foto',
    count: '+{extraPhotoCount} altre',
  },
  NumericKeyboard: {
    invalidPin: 'Codice PIN non valido',
    clear: 'Cancella',
    enter: 'Invio',
  },
  OutOfService: {
    message:
      'Il tuo contratto sembra essere in pausa o scaduto.\nContatta il tuo distributore per assistenza.',
  },

  /**
   * Steps
   */

  Home: {
    title: 'Genera il tuo ritratto in pochi secondi!',
    button: 'Prova ora!',
  },
  ArtStyle: {
    title: 'Scegli il tuo stile',
  },
  PhotoFromWebcam: {
    titleGetReady: 'Preparati a scattare una foto',
    titleAttention: 'Guarda la fotocamera!',
    titleReview: 'Ti piace questa foto?',
    titleUpload: 'Caricamento della foto…',
    buttonPrimaryPhoto: 'Scatta una foto',
    buttonPrimaryUse: 'Sì, usa questa foto',
    buttonPrimaryRetake: 'Rifai foto',
    buttonSecondaryUpload: 'Carica dal telefono',
    buttonSecondaryRetake: 'No, rifai (1 tentativo rimasto)',
    buttonSecondaryUseFirst: 'No, usa la prima foto',
    titleCameraError: 'Fotocamera non disponibile',
    buttonRetryCamera: 'Riprova fotocamera',
  },
  PhotoPromptFromPhone: {
    title: 'Caricare foto dal telefono?',
    caption:
      'Sorprendi amici e familiari —\ncarica le loro foto per creare ritratti.',
    buttonUpload: 'Sì, carica dal telefono',
    buttonSkip: 'No, salta caricamento',
  },
  PhotoFromPhone: {
    title: 'Carica foto dal tuo telefono',
    step1: 'Scansiona il codice QR con il telefono',
    step2: 'Seleziona le foto',
    step3: 'Attendi il caricamento',
    waiting: 'In attesa del caricamento…',
    done: 'Caricamento riuscito',
    buttonCancel: 'Annulla e torna indietro',
    buttonSkip: 'Salta caricamento dal telefono',
    buttonContinue: 'Continua',
    gdprConsentAll:
      'Ho il consenso di tutte le persone in questa foto per elaborare le loro caratteristiche facciali',
    gdprOver16: 'Nessuno in questa foto ha meno di 16 anni',
    gdprResponsibility:
      'Accetto la piena responsabilità per la conformità al GDPR',
    gdprAgreeToPrefix: 'Accetto i',
    gdprPrivacyPolicyLink: "termini dell'informativa sulla privacy",
    gdprAgreeToSuffix: 'per le foto caricate',
    gdprCheckboxesRequired:
      'Seleziona tutte le caselle qui sotto per continuare',
    buttonSkipKioskPhoto: 'Salta foto dal chiosco',
    buttonTakeWebcamPhoto: 'Scatta foto con la webcam',
  },
  FacesIndividual: {
    title: 'Di chi vuoi creare i ritratti individuali?',
    buttonConfirm: 'Conferma e continua',
    genderMale: 'Maschile',
    genderFemale: 'Femminile',
    genderNonBinary: 'Non-binario',
    age0to2: '0-2',
    age3to9: '3-9',
    age10to19: '10-19',
    age20to29: '20-29',
    age30to39: '30-39',
    age40to49: '40-49',
    age50to59: '50-59',
    age60to69: '60-69',
    age70plus: '70+',
    raceWhite: 'Bianco',
    raceBlack: 'Nero',
    raceEastAsian: 'Asiatico orientale',
    raceSoutheastAsian: 'Asiatico del sud-est',
    raceIndian: 'Indiano',
    raceLatino: 'Latino',
    raceMena: 'Mediorientale',
  },
  Portraits: {
    title: 'Scegli i tuoi ritratti!',
    buttonNext: 'Avanti: stampa selezionati',
    buttonNextGroupOnly: 'Continua solo con i ritratti di gruppo',
    galleryScrollBack: 'Ritratti precedenti',
    galleryScrollForward: 'Ritratti successivi',
    filterLabel: 'Mostra',
    filterAll: 'Tutti',
    filterGroup: 'Insieme',
    filterIndividual: 'Singoli',
    stageKindGroup: 'Ritratto di gruppo',
    stageKindIndividual: 'Ritratto',
    stagePosition: '{index} di {count}',
    stageSelect: 'Seleziona',
    stageSelected: 'Selezionato ✓',
    buttonMore: 'Crea altri ritratti ({count} rimasti)',
    popupTitle: "Vuoi concludere l'ordine?",
    popupGroupSelected: 'Ritratti di gruppo selezionati: {count} ({price})',
    popupIndividualSelected:
      'Ritratti individuali selezionati: {count} ({price})',
    popupTotalSum: 'Totale: {sum}',
    popupButtonNo: 'No, torna indietro',
    popupButtonYes: 'Sì, stampa e paga!',
    error: 'Ops! Impossibile generare questo ritratto.',
    placeholderGenerating: 'Generazione del ritratto…',
    placeholderLoading: 'Caricamento del ritratto…',
    groupPlaceholder: 'Il tuo ritratto di gruppo apparirà qui',
    buttonRetry: 'Riprova',
    buttonErrorDetails: "Dettagli dell'errore",
    retrying: 'Nuovo tentativo...',
    maxRetriesReached: 'Max tentativi raggiunti',
    retryAttempts: 'Tentativi: {count}',
    printingLockedPopupTitle:
      'Per favore chiama il membro dello staff più vicino per stampare i tuoi ritratti.',
    generationPendingTitle: 'Alcuni ritratti sono ancora in fase di creazione',
    generationPendingCaption:
      'Sono ancora in fase di creazione {count} ritratti. Vuoi aspettare per vederli tutti?',
    generationPendingWait: 'Aspetta tutti i ritratti',
    generationPendingSendReady: 'Invia {count} ritratti pronti',
    printingLockedPopupCaption:
      'La stampa al chiosco non è disponibile quando nessun membro dello staff è presente.',
  },
  PortraitsGroup: {
    buttonMore: 'Crea altri ritratti',
  },
  PrintLock: {
    lockTitle: 'Blocca stampa',
    unlockTitle: 'Sblocca stampa',
  },
  PaymentType: {
    title: 'Come vuoi pagare?',
    optionCardTitle: 'Carta di credito',
    optionCardCaption: 'Visa, Mastercard, & 10+ carte supportate',
    optionVoucherTitle: 'Ritratti Prepagati',
    optionVoucherCaption: 'Inclusi nel biglietto — chiedi al personale',
  },
  PaymentTerminal: {
    title: 'Segui le istruzioni sullo schermo',
    titlePaymentSuccess: 'Stampa dei tuoi ritratti…',
    titlePaymentError: 'Pagamento fallito',
    titlePrintError1: 'Spiacenti, alcuni ritratti non sono stati stampati',
    titlePrintError2:
      'Per favore, premi "Stampa di nuovo" qui sotto per riprovare.',
    buttonRetryPrinting: 'Stampa di nuovo',
    buttonRetry: 'Riprova',
    buttonCancel: 'Annulla',
    buttonExitSession: 'Ricomincia',
    buttonBack: 'Indietro',
    total: 'Totale:',
    captionPayment: 'In attesa del pagamento…',
    captionPrinting: 'Stampa completata',
    captionPaymentError: 'Qualcosa è andato storto. Riprova o ricomincia.',
    captionPaymentFinal:
      'Il pagamento non è andato a buon fine. Chiedi aiuto al personale.',
    failureCaptions: {
      notEnoughFunds:
        "Fondi insufficienti sulla carta. Prova con un'altra carta.",
      expiredCard: "La carta è scaduta. Prova con un'altra carta.",
      cardDeclined: "La carta è stata rifiutata. Prova con un'altra carta.",
      cardError:
        "Questa carta non può essere usata qui. Prova con un'altra carta.",
      processingError:
        'Il pagamento non è andato a buon fine. Riprova con la stessa carta.',
      readerError:
        'Il lettore di carte non è disponibile. Chiedi aiuto al personale.',
      timeout: 'Il pagamento ha richiesto troppo tempo. Riprova.',
    },
    errorMessage: 'Spiacenti, non abbiamo potuto elaborare il tuo pagamento',
    popupCancelledTitle: 'Pagamento annullato',
    popupCancelledCaption: 'Vuoi riprovare o ricominciare?',
    popupButtonContinue: 'Riprova',
  },
  PaymentVoucher: {
    title:
      'Per favore, contatta un dipendente per aiutarti a pagare con un voucher',
    buttonBack: 'Indietro',
    pinTitle: 'Paga con voucher',
  },
  Printing: {
    title: 'Stampa dei tuoi ritratti…',
    titleError: 'Spiacenti, alcuni ritratti non sono stati stampati',
    buttonPrintAgain: 'Stampa di nuovo',
    buttonContinueWithoutPrint: 'Continua senza stampare',
    error: 'Ops! Impossibile stampare questo ritratto.',
    errorPartial: '{printed} di {total} stampati',
    retrying: 'Nuovo tentativo…',
    waiting: 'In attesa della stampante…',
  },
  PrintFailed: {
    title: 'Spiacenti, non siamo riusciti a stampare le tue foto',
    titlePartial: '{printed} foto su {total} stampate',
    caption: 'Puoi iniziare una nuova sessione e creare nuovi ritratti.',
    captionRefunded: 'Abbiamo rimborsato {amount} sulla tua carta.',
    captionNotCharged: 'Non ti abbiamo addebitato {amount}.',
    captionRefundHelp: 'Un membro dello staff ti aiuterà con il rimborso.',
  },
  Success: {
    title: 'Grazie!',
    caption: 'I tuoi quadri sono stati stampati.\n Ritirali al banco.',
    buttonStartAgain: 'Ricomincia',
  },
  GoPhotoScan: {
    title: 'Scansiona il tuo PhotoPass',
    subtitle: 'Mostra il codice QR del PhotoPass allo scanner',
    invalidCode: 'Formato codice non valido. Riprova la scansione.',
    failedToRegister: 'Registrazione codice fallita. Riprova.',
    error: 'Si è verificato un errore. Riprova.',
  },

  /**
   * Customer-facing components
   */

  CustomerPhotoFromPhone: {
    title: 'Carica foto dalla galleria',
    buttonSelect: 'Seleziona foto',
    maxCount: 'Massimo {count} foto',
    uploading: 'Caricamento…',
    uploadError: 'Caricamento fallito. Controlla la connessione e riprova.',
    buttonRetry: 'Riprova',
    successTitle: 'Caricamento riuscito',
    successCaption: 'Torna al chiosco e segui le istruzioni sullo schermo.',
  },
  CustomerPortraitsDownload: {
    title: 'Inserisci il codice per ottenere il ritratto',
    buttonSubmit: 'Invia',
    error:
      'Questo codice non sembra corretto. Controlla il codice di 8 caratteri stampato sulla foto e riprova.',
    errors: {
      wrongFormat:
        'Questo codice non sembra corretto. Controlla il codice di 8 caratteri stampato sulla foto e riprova.',
      notFound:
        'Ci dispiace, nessun ritratto trovato. Per favore controlla il codice — è stampato sulla parte anteriore del ritratto, in basso a sinistra.',
      serverError:
        'Ci dispiace, non siamo riusciti a recuperare i tuoi ritratti in questo momento. Per favore riprova più tardi.',
    },
  },
  CustomerSessionPass: {
    tabs: {
      photos: 'Foto',
      pass: 'Pass QR',
    },
    eyebrow: 'Il tuo pass sessione',
    title: 'Tieni aperta questa pagina',
    description:
      'Alla postazione di acquisto, scansiona il codice quadrato qui sotto. I tuoi ritratti sono disponibili nella scheda Foto.',
    descriptionNothingPrinted:
      'Alla postazione di vendita, scansiona il codice quadrato qui sotto per scegliere e stampare le tue foto.',
    scanLabel: 'Scansiona alla postazione di acquisto',
    codeLabel: 'Codice sessione',
    ready: 'Pronto per la scansione',
    loading: 'Preparazione del codice',
    unavailable: 'Codice non disponibile',
    qrAlt: 'Codice QR per la postazione di acquisto',
    defaultVenue: 'Esperienza ritratto TheArtisan.ai',
  },
  CustomerPortraitsDownloadCode: {
    error: 'Ops! Impossibile caricare questo ritratto.',
    placeholder: 'Caricamento del ritratto…',
    imageAlt: 'Ritratto',
    buttonDownload: 'Scarica',
    buttonSendOrShare: 'Invia o condividi',
    buttonRetry: 'Riprova',
    shareTitle: 'Il tuo ritratto da {clientName}',
    shareText: 'Offerto da TheArtisan.ai',
    states: {
      processing:
        'I tuoi ritratti sono ancora in preparazione. Riprova tra poco.',
      partial:
        'Non è stato possibile caricare alcuni ritratti o dettagli della pagina. I download disponibili continuano a funzionare.',
    },
    actions: {
      enterAnotherCode: 'Inserisci un altro codice',
      contactSupport: 'Contatta il supporto',
      retryDownload: 'Riprova il download',
      downloadFailed:
        'Download non riuscito. Controlla la connessione e riprova.',
      linkCopied: 'Link copiato. Puoi incollarlo in un messaggio.',
      shareFailed: 'La condivisione non è disponibile al momento. Riprova.',
    },
  },
  CustomerDigitalExtras: {
    downloadTitle: 'Le tue foto e gli extra',
    downloadIntro: 'Salva le foto, scarica gli extra o apri il biglietto QR.',
    photosTitle: 'Le tue foto',
    photosIntro: 'Salva le tue foto o apri il pass QR.',
    navigation: 'I tuoi download',
    tabs: {
      photos: 'Foto',
      extras: 'Video',
      pass: 'Biglietto QR',
    },
    title: 'I tuoi extra digitali',
    loading: 'Caricamento dei tuoi extra…',
    loadError: 'Impossibile caricare i file. Controlla la connessione.',
    included: 'Incluso',
    includedOrder:
      'Il tuo video è incluso. Conserva il biglietto QR per aprirlo più tardi.',
    preparingHelp:
      'Salva questo link o conserva il biglietto QR. Puoi chiudere questa pagina e tornare più tardi.',
    reference: 'Riferimento: {reference}',
    retry: 'Riprova',
    empty: 'Non sono stati aggiunti extra digitali a questa visita.',
    orderTitle: 'Ordine video',
    showCashier: 'Mostra questo ordine e il biglietto QR alla cassa.',
    videoTotal: 'Totale video',
    payAtDesk: 'Pagamento alla cassa.',
    preparing: 'Preparazione dei file…',
    failed:
      'Non è stato possibile creare il tuo video. Mostra il riferimento qui sotto al personale per ricevere aiuto.',
    ready: 'Pronto da scaricare',
    video: 'Foto animata',
    videoDescription:
      'Il tuo momento preferito in movimento. Per le storie e la chat di famiglia.',
    download: 'Scarica',
    share: 'Condividi file',
    preparingShare: 'Caricamento del file…',
    shareFailed: 'Condivisione non disponibile. Scarica il file.',
  },
  GoPhotoUpload: {
    waitingForPortraits: 'Completamento dei tuoi ritratti',
    waitingForPortraitsSubtitle:
      'Attendi mentre vengono creati i ritratti rimanenti.',
    success: 'Foto caricate!',
    successSubtitle: 'Le tue foto sono ora disponibili sul tuo PhotoPass.',
  },
  system: {
    reconnecting: 'Riconnessione al server…',
  },
} satisfies LocaleMessageSchema;
